import { ThemedExample } from '#src/components/ThemedExample/ThemedExample.tsx';
import {
  Actions,
  Alert,
  Box,
  Button,
  Dropdown,
  IconAdd,
  IconLocation,
  IconMoney,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
  Text,
  TextField,
  TextLinkButton,
} from 'braid-design-system';
import { useState } from 'react';

export const JobAdList = () => (
  <ThemedExample>
    <Stack space="medium">
      <Text size="large" weight="strong">
        Senior business analyst
      </Text>

      <Text icon={<IconMoney />} size="small">
        AUD 100,000–130,000
      </Text>
      <Text icon={<IconLocation />} size="small">
        Perth, Australia
      </Text>

      <Actions>
        <Button size="small" variant="soft">
          Edit
        </Button>
        <Button size="small" variant="soft">
          Close
        </Button>
      </Actions>

      <Text weight="strong">Job ads</Text>

      <Table label="Job ads">
        <TableHeader>
          <TableRow>
            <TableHeaderCell>
              <Text>Reference</Text>
            </TableHeaderCell>
            <TableHeaderCell>
              <Text>Title</Text>
            </TableHeaderCell>
            <TableHeaderCell>
              <Text>Source</Text>
            </TableHeaderCell>
            <TableHeaderCell>
              <Text>Status</Text>
            </TableHeaderCell>
            <TableHeaderCell>
              <Text>Created</Text>
            </TableHeaderCell>
          </TableRow>
        </TableHeader>

        <TableBody>
          <TableRow>
            <TableCell>
              <Text>AD-123</Text>
            </TableCell>
            <TableCell>
              <Text>Senior business analyst</Text>
            </TableCell>
            <TableCell>
              <Text>SEEK (Ad Sync)</Text>
            </TableCell>
            <TableCell>
              <Text>Active</Text>
            </TableCell>
            <TableCell>
              <Text>2048-01-01</Text>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell>
              <Text>AD-124</Text>
            </TableCell>
            <TableCell>
              <Text>Experienced BA wanted</Text>
            </TableCell>
            <TableCell>
              <Text>Job board X</Text>
            </TableCell>
            <TableCell>
              <Text>Active</Text>
            </TableCell>
            <TableCell>
              <Text>2048-01-02</Text>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell colspan={6}>
              <Button
                icon={<IconAdd />}
                size="small"
                tone="formAccent"
                variant="soft"
              >
                Create new job ad
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Stack>
  </ThemedExample>
);

export const JobPostingForm = () => {
  const [req, setReq] = useState('1');
  const [title, setTitle] = useState('Senior business analyst');

  return (
    <ThemedExample>
      <Stack space="medium">
        <Text size="large" weight="strong">
          Post a job ad
        </Text>

        <Dropdown
          label="Job requisition"
          onChange={(event) => setReq(event.currentTarget.value)}
          value={req}
        >
          <Box component="option" value="1">
            Senior business analyst
          </Box>
          <Box component="option" value="2">
            Principal developer
          </Box>
          <Box component="option" value="3">
            Project manager
          </Box>
        </Dropdown>

        <Alert tone="info">
          <Text>
            You have existing job ads for this position.{' '}
            <TextLinkButton onClick={() => undefined}>
              View job ads.
            </TextLinkButton>
          </Text>
        </Alert>

        <TextField
          disabled
          label="Job title"
          onChange={(event) => setTitle(event.currentTarget.value)}
          value={title}
        />

        <Text>…</Text>
      </Stack>
    </ThemedExample>
  );
};
